module.exports = __webpack_public_path__ + "static/media/morion-regular.c5d43538.woff2";